// extracted by mini-css-extract-plugin
export default {"trash":"ChatWorkBox_trash__LvLQu"};